import React from "react";

import { copy } from "shared/assets";
import { IStageCapacity } from "Venues/types";
import { DeleteModal } from "shared/components";
import { IAPIState } from "shared/types";

const { stageProperties } = copy;

interface DeleteCapacityModalProps {
  capacity?: IStageCapacity;
  apiMeta?: { status: IAPIState; error?: any };
  handleDelete: (id?: string) => void;
  handleClose: () => void;
}

export const DeleteCapacityModal: React.FC<DeleteCapacityModalProps> = ({
  capacity,
  handleDelete,
  ...rest
}) => {
  const onDelete = () => {
    handleDelete(capacity?.id);
  };

  return (
    <DeleteModal
      handleDelete={onDelete}
      type={stageProperties.capacities.properties.capacity.title}
      name={capacity?.title || ""}
      {...rest}
    />
  );
};
